module.exports = __webpack_public_path__ + "img/nav3@2x.3690c4de.png";